<script lang="ts">
  export let hasVotedBefore
  export let submitting
  $: hypeUrl = 'img/party_hype.gif'
</script>

<style>
  .submit_btn {
    display: flex;
  }
  .submit_btn img {
    height: 2rem;
    margin-left: 1rem;
  }
</style>

<svelte:head>
  <link rel="preload" as="image" href={hypeUrl} />
</svelte:head>

<div class="submit_btn">
  <input type="submit" disabled={submitting} value={submitting ? 'submitting...' : hasVotedBefore ? 'update' : 'submit'} />
  {#if submitting}
    <img src={hypeUrl} alt="submitting" />
  {/if}
</div>